export const iconFontAwesomeUsersPeoplePeopleArrows = (
	<i className="fa-solid fa-people-arrows"></i>
);
